<div class="courses-sidebar-information">
    <ul *ngFor="let specialty of specialites">
        <li *ngIf="specialty.active">
            <a href="specialitati-medicale/{{specialty.friendlyUrl}}">
                <span><i class='{{specialty.photoIcon}}'></i>{{specialty.name}}</span>
            </a>
        </li>

    </ul>
</div>
